import { Http } from './http';

class PaymentScheduleHttp extends Http {
  prefix = 'payment-schedule';

  async updateBulk(params: UpdateBulkParams): Promise<number> {
    const { data } = await this.put<number>('/update-bulk', params);

    return data;
  }
}

export const paymentScheduleHttp = new PaymentScheduleHttp();

interface UpdateBulkParams {
  selectedIds: number[];
  prop: string;
  value: string | number | null;
}

